import { ReactNode } from "react";
import Text from "@ingka/text";
import { TextStyles } from "@ingka/typography-shared";

import "@ingka/text/dist/style.css";

interface TextProps {
  textStyle?: TextStyles;
  className?: string;
  children?: ReactNode;
  tagName?: "h1" | "h2" | "h3" | "h4" | "p";
  dangerouslySetInnerHTML?: { __html: string };
  onClick?: () => void;
  id?: string;
}

export const FixaText = (props: TextProps) => {
  return <Text {...props}>{props.children}</Text>;
};
